export default __webpack_public_path__ + "static/media/ngo-a035-1.15a2843a.jpg";